import type { ResultOf } from '@newfront-insurance/graphql-frontend';
import { graphql } from '@newfront-insurance/graphql-frontend';

export const GET_CHATS_BY_FILTERS = graphql(`
  query GetChatsByFilters($userUuid: String, $accountUuid: String, $appType: AppType) {
    chatsList: getChats(userUuid: $userUuid, accountUuid: $accountUuid, appType: $appType) {
      uuid
      userUuid
      accountUuid
      appType
      title
      summary
      createdAt
      updatedAt
      lastMessageAt
      hasUnreadMessages
      activeStreamId
    }
  }
`);

export type GetChatsByFilters = NonNullable<ResultOf<typeof GET_CHATS_BY_FILTERS>['chatsList']>;
export type GetChatsByFiltersChat = GetChatsByFilters[number];
export type ChatAppType = GetChatsByFiltersChat['appType'];

export const GET_CHAT_WITH_MESSAGES = graphql(`
  query GetChatWithMessages($uuid: String!) {
    getChat(uuid: $uuid) {
      uuid
      userUuid
      accountUuid
      activeStreamId
      title
      summary
      createdAt
      updatedAt
      hasUnreadMessages
      appType
      account {
        uuid
        name
      }
      messages {
        uuid
        chatUuid
        reaction
        role
        files {
          uuid
          filename
        }
        parts
        metadata
        createdAt
      }
    }
  }
`);

export type GetChatWithMessages = NonNullable<ResultOf<typeof GET_CHAT_WITH_MESSAGES>['getChat']>;
export type GetChatWithMessagesMessage = GetChatWithMessages['messages'][number];

export const GET_ACCOUNT = graphql(`
  query GetAccount($uuid: String!) {
    getAccount(uuid: $uuid) {
      uuid
      name
      programType
    }
  }
`);

export type GetAccount = NonNullable<ResultOf<typeof GET_ACCOUNT>['getAccount']>;

export const GET_SKILLS = graphql(`
  query GetSkills {
    skills: getSkills {
      id
      name
      description
      category
      exampleUsage
      instructionPlaceholder
    }
  }
`);

export type GetSkills = NonNullable<ResultOf<typeof GET_SKILLS>['skills']>;
export type NovaSkill = GetSkills[number];
